import {useEffect, useState} from "react";
import {MAP_CONFIG} from "../utils/constants";

export function useMapZoom(map: google.maps.Map | null) {
    const [zoom, setZoom] = useState(map?.getZoom() ?? MAP_CONFIG.DEFAULT_ZOOM);

    useEffect(() => {
        if (!map) return;
        const listener = map.addListener("zoom_changed", () => {
            setZoom(map.getZoom() ?? MAP_CONFIG.DEFAULT_ZOOM);
        });
        return () => listener.remove();
    }, [map]);

    return zoom;
}
